export default "__VITE_ASSET__DSVQWTZ6__"